import { render, staticRenderFns } from "./SMenuOptGroupForStoreView.vue?vue&type=template&id=94278d16&scoped=true"
import script from "./SMenuOptGroupForStoreView.vue?vue&type=script&lang=js"
export * from "./SMenuOptGroupForStoreView.vue?vue&type=script&lang=js"
import style0 from "./SMenuOptGroupForStoreView.vue?vue&type=style&index=0&id=94278d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94278d16",
  null
  
)

export default component.exports